/**
 * @desc Snowmaking fanguns state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "airwaterguns",
    layerTitle: "Air/Water guns",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: true,
    legend: [
      {
        id: 1,
        name: "Boomstick Double | Ratnik",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1001.png"
      },
      {
        id: 2,
        name: "Boomstick Single | Ratnik",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1002.png"
      },
      {
        id: 3,
        name: "5' York | Borax",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1003.png"
      },
      {
        id: 4,
        name: "Striker/Stealth",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1005.png"
      },
      {
        id: 5,
        name: "Viper Phaser/ SV 12",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1006.png"
      },
      {
        id: 6,
        name: "Viper Phaser/ SV 12",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1007.png"
      },
      {
        id: 7,
        name: "Rat V",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1008.png"
      },
      {
        id: 8,
        name: "Top Gun| Land",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1012.png"
      },
      {
        id: 9,
        name: "K Gun",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1014.png"
      },
      {
        id: 11,
        name: "Ringer",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1016.png"
      },
      {
        id: 12,
        name: "York | Borax | Skid",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2003.png"
      },
      {
        id: 13,
        name: "Omnicron",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2007.png"
      },
      {
        id: 14,
        name: "Phazer | Volt R5",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2008.png"
      },
      {
        id: 15,
        name: "Ratnik | Renegade| Skid",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2009.png"
      },
      {
        id: 16,
        name: "Rubis",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2010.png"
      },
      {
        id: 17,
        name: "SV14 | Volt R5 | Skid",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2011.png"
      },
      {
        id: 18,
        name: "Viking",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2013.png"
      },
      {
        id: 19,
        name: "York | Borax | Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3003.png"
      },
      {
        id: 20,
        name: "Double York | Borax | Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3004.png"
      },
      {
        id: 21,
        name: "DV4 | Snow Logic",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3005.png"
      },
      {
        id: 22,
        name: "SV12 | Impulse",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3006.png"
      },
      {
        id: 23,
        name: "Phazer | Volt R5",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3008.png"
      },
      {
        id: 24,
        name: "Ratnik | Renegade | Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3009.png"
      },
      {
        id: 25,
        name: "SV14 | Volt R5",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3011.png"
      },
      {
        id: 26,
        name: "Top Gun| Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3012.png"
      },
      {
        id: 27,
        name: "Viking | Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3013.png"
      },
      {
        id: 28,
        name: "Demaclenko Visup",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3014.png"
      },
      {
        id: 29,
        name: "Lance | Techno Alpin",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3015.png"
      }
    ]
  }
};
